import ContactsIcon from "assets/menu-icons/ContactsIcon";

const contacts = {
  id: 'contacts',
  type: 'group',
  visible: true,
  children: [{
    id: 'contacts',
    title: 'Контакты', 
    type: 'item',
    url: '/contacts',
    icon: ContactsIcon,
    breadcrumbs: false,
    visible: true,
  }]
}

export default contacts;